import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/i18n";
import { Reveal, LineMask } from "@/components/Reveal";

const Programs = () => {
  const { t } = useLang();
  const p = t.programs;
  const [open, setOpen] = useState(null);

  return (
    <section className="programs section-dark" id="programmi" aria-labelledby="programs-title" data-testid="programs-section">
      <div className="shell">
        <div className="section-heading">
          <Reveal className="section-index" aria-hidden="true">{p.index}</Reveal>
          <div>
            <Reveal><p className="kicker">{p.kicker}</p></Reveal>
            <h2 id="programs-title" className="display-title">
              <LineMask delay={0.1}>{p.titleA}</LineMask>
              <LineMask delay={0.22}><span>{p.titleB}</span></LineMask>
            </h2>
          </div>
        </div>

        <div className="programs-grid">
          {p.cards.map((card, i) => (
            <Reveal key={card.tag} className={`program-card ${card.cls}`} delay={i * 0.08} data-testid={`program-card-${i}`}>
              <div className="p-img" style={{ backgroundImage: `url(${card.img})` }} aria-hidden="true" />
              <div className="p-content">
                <small className="p-tag">{card.tag}</small>
                <h3>{card.title}</h3>
                <p>{card.text}</p>
                <button
                  className="p-toggle"
                  type="button"
                  onClick={() => setOpen(open === i ? null : i)}
                  aria-expanded={open === i}
                  data-testid={`program-toggle-${i}`}
                >
                  {open === i ? card.close : card.toggle}
                  <motion.span animate={{ rotate: open === i ? 45 : 0 }} transition={{ duration: 0.25 }}>＋</motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      className="p-exercises"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.2, 0.7, 0.2, 1] }}
                      data-testid={`program-exercises-${i}`}
                    >
                      {card.exercises.map(([name, scheme]) => (
                        <div className="p-ex" key={name}>
                          <span>{name}</span>
                          <b>{scheme}</b>
                        </div>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;
